const policy =
`<p>欢迎使用杭州笑口杏信息科技有限公司运营的平台服务。为使用本平台服务，您应当阅读并遵守《用户注册协议》和《隐私政策》。本政策是您与杭州笑口杏信息科技有限公司之间关于个人信息处理规则的重要文件，适用于您注册平台账号、登录平台、发布信息、浏览内容、进行业务咨询及使用其他相关服务的全过程。请您务必审慎阅读、充分理解各条款内容。除非您已阅读并接受本政策全部内容，否则您无权使用本平台提供的相关服务；您使用本平台服务即视为您已阅读并同意本政策的约束。</p>
<div class="bold">
  <p>本隐私政策（以下简称“本政策”）适用于杭州笑口杏信息科技有限公司（以下简称“我们”）运营的网站、客户端及相关平台服务。在使用本平台各项服务前，请您务必仔细阅读并透彻理解本政策，并做出您认为适当的选择。依照相关法律法规规定及监管要求，或为满足用户身份真实核验、保障系统和服务安全、企业资质审核及其他特定服务功能等需要，我们可能需要您提供真实身份信息，例如姓名、联系电话、身份证明信息、公司名称、营业执照、联系人信息等。如您不提供前述信息，您可能无法注册账号、发布信息、完成企业认证或正常使用部分服务。一旦您开始使用本平台的各项服务，即表示您已充分理解并同意本政策。需要提醒您注意的是，本隐私政策仅适用于我们依法收集和处理的信息。</p>
  <p>本政策将帮助您了解以下内容：</p>
  <p>1、我们如何收集和使用您的个人信息</p>
  <p>2、我们如何使用 Cookie</p>
  <p>3、我们如何共享、转让、公开披露您的个人信息</p>
  <p>4、我们如何保护您的个人信息</p>
  <p>5、您的权利</p>
  <p>6、本政策如何更新</p>
  <p>7、如何联系我们</p>
  <p>相关术语及定义</p>
  <p>1、本平台：指由杭州笑口杏信息科技有限公司运营的网站、客户端及相关服务载体。</p>
  <p>2、个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
  <p>3、收集：指获得对个人信息的控制权的行为，包括由个人信息主体主动提供、通过与个人信息主体交互或记录个人信息主体行为等自动采集，以及通过共享、转让、搜集公开信息等方式间接获取。</p>
  <p>4、删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。</p>
  <p>5、公开披露：指向社会或不特定人群发布信息的行为。</p>
  <p>6、转让：指将个人信息控制权由一个控制者向另一个控制者转移的过程。</p>
  <p>7、共享：指个人信息控制者向其他控制者提供个人信息，且双方分别对个人信息拥有独立控制权的过程。</p>
  <p>一、我们如何收集和使用您的个人信息</p>
  <p>（一）我们如何收集您的个人信息</p>
  <p>您在使用本平台提供的服务时，为了更好地实现信息发布、业务展示、供需对接、咨询沟通、平台运营及安全保障等目的，我们可能收集和使用您的个人信息。如您拒绝提供相关信息，您可能无法注册账号或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。收集的情形包括：</p>
  <p>1、您主动提供的信息，包括但不限于：</p>
  <p>(1)您在注册平台账号时提供的信息，例如手机号、昵称、密码等；</p>
  <p>(2)您在完善账户资料或申请企业身份时提供的信息，例如姓名、公司名称、联系人、营业执照、联系地址等；</p>
  <p>(3)您在使用广告策划、企业咨询、数字内容制作、系统平台搭建、信息发布或其他服务过程中主动提交的信息、图片、说明材料及沟通内容。</p>
  <p>2、在您使用服务过程中获取的信息，包括但不限于：</p>
  <p>(1)设备信息，例如浏览器类型、移动设备信息、设备标识符、IP 地址等；</p>
  <p>(2)日志信息，例如访问页面 URL、搜索关键词、操作时间、访问来源、异常报错信息等；</p>
  <p>(3)为保障交易和服务安全所需的信息，例如登录状态、操作记录、风控校验信息等；</p>
  <p>(4)您使用第三方账号登录或授权时，经您授权后获取的头像、昵称等必要信息。</p>
  <p class="none">（二）我们如何使用您的个人信息</p>
  <p class="none">1、我们会在法律法规要求或本平台相关服务条款约定的情况下，基于如下目的使用您的个人信息：</p>
  <p class="none">(1)向您提供平台账号注册、登录、信息发布、内容展示、业务咨询、供需对接、交易撮合等服务，并维护、改进这些服务；</p>
  <p class="none">(2)开展企业资质审核、实名认证、安全风控、投诉处理、客户服务及运营管理；</p>
  <p class="none">(3)向您推荐您可能感兴趣的产品、服务或内容，如您不希望接收相关信息，可通过相应方式取消接收；</p>
  <p class="none">(4)对平台使用情况进行统计、分析和优化，以提升产品体验和服务质量；</p>
  <p class="none">(5)储存并维护用户信息，以履行运营管理、审计留痕、争议处理及法律义务；</p>
  <p class="none">(6)经您同意的其他目的。<span></span></p>
  <p class="none">2、需要提醒您注意的是，在以下情形中，使用您的个人信息无需您的同意：</p>
  <p class="none">(1)与国家安全、国防安全直接相关的；</p>
  <p class="none">(2)与公共安全、公共卫生、重大公共利益直接相关的；</p>
  <p class="none">(3)与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
  <p class="none">(4)出于维护您或其他个人生命、财产等重大合法权益但又很难得到本人同意的；</p>
  <p class="none">(5)用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务故障；</p>
  <p class="none">(6)法律法规规定的其他情形。<span></span></p>
  <p>二、我们如何使用 Cookie</p>
  <p>使用 Cookie 能帮助您实现更便捷、更个性化的使用体验。您可以接受或拒绝 Cookie，大多数 Web 浏览器会自动接受 Cookie，但您通常可根据自己的需要修改浏览器设置以拒绝 Cookie。Cookie 不会直接跟踪您的敏感个人信息。</p>
  <p>当您访问或登录本平台时，我们可能会使用 Cookie 或类似技术识别您的身份、保存登录状态、优化浏览体验及提升服务效率。来自本平台的 Cookie 仅能被本平台读取。如果您的浏览器被设置为拒绝 Cookie，您仍然能够访问本平台的大多数页面，但部分功能可能无法正常使用。</p>
  <p>三、我们如何共享、转让、公开披露您的个人信息</p>
  <p>（一）共享</p>
  <p>尊重并保护用户个人隐私是我们的一项基本原则。除以下情形外，我们不会与任何公司、组织和个人共享您的个人信息：</p>
  <p>1、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</p>
  <p>2、与授权合作伙伴共享：我们可能委托授权合作伙伴为您提供某些技术支持、信息审核、数据存储、客户服务等服务，我们仅会出于本隐私政策声明的合法、正当、必要、特定、明确的目的共享您的信息，且授权合作伙伴不得将此信息用于其他任何目的。</p>
  <p>（二）转让</p>
  <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
  <p>在涉及合并、收购、重组或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
  <p>（三）公开披露</p>
  <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
  <p class="none">1、获得您单独同意或授权的；</p>
  <p class="none">2、基于法律、法律程序、诉讼或政府主管部门强制性要求进行披露的。<span></span></p>
  <p>四、我们如何保护您的个人信息</p>
  <p>（一）我们会采取合理可行的安全措施，确保未收集与业务无关的个人信息。我们仅会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律法规另有要求或允许。</p>
  <p>（二）我们已使用符合行业标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失，包括但不限于访问控制、日志审计、传输加密、权限隔离等措施。</p>
  <p>（三）互联网并非绝对安全的环境，且电子邮件、即时通讯及其他沟通方式并非完全加密，我们强烈建议您不要通过此类方式发送敏感个人信息，并请妥善保管账户密码、验证码等信息。</p>
  <p>（四）在不幸发生个人信息安全事件后，我们将按照法律法规要求及时向您告知安全事件的基本情况、可能影响、已采取或将采取的处置措施、您可自主防范和降低风险的建议及补救措施等，并按照监管要求主动上报处置情况。</p>
  <p>五、您的权利</p>
  <p>无论您何时使用本平台，我们都会尽力保障您对个人信息的查询、更正、删除和管理权利。按照法律及通行做法，为使您拥有充分能力保障自身隐私和安全，您拥有如下权利：</p>
  <p>（一）访问您的个人信息</p>
  <p>除法律法规规定外，您有权随时访问您的个人信息，包括账户资料、已提交的信息及与平台服务相关的必要记录。如果您无法自行访问，可随时联系我们。</p>
  <p>（二）更正您的个人信息</p>
  <p>当您发现您所填写的或者我们处理的关于您的个人信息有错误时，您有权自行更正；当您无法自行更正时，您可以随时联系我们，我们将尽快回复您的更正请求。</p>
  <p>（三）删除您的个人信息</p>
  <p>除法律法规规定外，您有权随时自行删除或者联系我们删除您的信息。在以下情形中，您可以向我们提出删除个人信息的请求：</p>
  <p>1、我们处理个人信息的行为违反法律法规的；</p>
  <p>2、我们收集、使用您的个人信息，却未征得您的同意的；</p>
  <p>3、我们处理个人信息的行为违反了与您的约定的；</p>
  <p>4、您不再使用我们的产品或服务，或您注销了账号的；</p>
  <p>5、我们不再为您提供产品或服务的。</p>
  <p>（四）注销／删除账号</p>
  <p>您可以选择注销／删除本平台账号，账号被注销／删除后原则上不可恢复。除法律法规另有规定外，您的个人信息将被删除或匿名化处理，建议您提前做好备份。</p>
  <p>（五）响应您的上述请求</p>
  <p>为保障安全，您可能需要提供书面请求或以其他方式证明您的身份。我们可能会先要求您验证身份，然后再处理您的请求。</p>
  <p>我们将尽快作出答复。对于无端重复、需要过多技术手段、给他人合法权益带来风险或非常不切实际的请求，我们可能会在说明理由后予以拒绝。</p>
  <p class="none">在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
  <p class="none">1、与国家安全、国防安全直接相关的；</p>
  <p class="none">2、与公共安全、公共卫生、重大公共利益直接相关的；</p>
  <p class="none">3、与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
  <p class="none">4、有充分证据表明您存在主观恶意或滥用权利的；</p>
  <p class="none">5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
  <p class="none">6、涉及商业秘密的。<span></span></p>
  <p>六、本政策如何更新</p>
  <p>我们的隐私政策可能会适时变更。</p>
  <p>通常情况下，我们不会削减您按照本隐私政策所应享有的权利。对于重大变更，我们会在本页面上发布或以其他合理方式通知您。若您在本政策更新后继续使用我们的服务，即表示您同意受修订后的本政策约束。</p>
  <p>本政策所指的重大变更包括但不限于：</p>
  <p>1、我们的服务模式发生重大变化，例如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
  <p>2、我们在所有权结构、组织架构等方面发生重大变化，例如业务调整、破产并购等引起的所有者变更等；</p>
  <p>3、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
  <p>4、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
  <p>5、个人信息安全影响评估报告表明存在高风险时。</p>
  <p>我们还会将本政策的历史版本存档，供您查阅。</p>
  <p>七、如何联系我们</p>
  <p>如果您对本隐私政策有任何疑问、意见或建议，可以致电 13282812933 联系我们。一般情况下，我们将在十五个工作日内回复。</p>
  <p>如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您可以向杭州笑口杏信息科技有限公司实际运营者所在地有管辖权的人民法院提起诉讼解决。</p>
  <p class="none">再次郑重提示并说明：请您认真、仔细阅读《用户注册协议》和《隐私政策》各项内容，尤其应重点关注特别标注部分。若您已全部知悉并理解相关内容，请勾选“已阅读并同意《用户注册协议》《隐私政策》”。</p>
</div>
`
export default policy
